import { useEffect, useState } from 'react';
import useFetch, { muteAll } from 'hooks/useFetch';
import { useAppSelector } from 'store/hooks';
import { selectMostHeldStocks } from '../reducers/selectors';
import { getMostHeldStocks } from '../actions';
// Sections only show this many; "See all" fetches its own longer list.
const MOST_HELD_STOCKS_LIMIT = 3;
/**
 * Fires an API request to update the list of most held stocks on mount.
 *
 * @returns Whether the request has finished, successfully or not.
 */
export function useFetchMostHeldStocks(enabled = true) {
    const [isSettled, setIsSettled] = useState(false);
    const [, , , fetch] = useFetch(muteAll);
    useEffect(() => {
        if (!enabled)
            return undefined;
        let isMounted = true;
        fetch(getMostHeldStocks(MOST_HELD_STOCKS_LIMIT)).finally(() => {
            if (isMounted)
                setIsSettled(true);
        });
        return () => {
            isMounted = false;
        };
    }, [enabled]);
    return isSettled;
}
/**
 * Most held stocks are fetched and cached into persisted store.
 * This hook will fire an API request to update the list of top trending stocks on mount,
 * unless `shouldFetch` is false because a parent already fetches them.
 *
 * @returns The array of most watched stocks.
 */
function useMostHeldStocks({ shouldFetch = true } = {}) {
    const mostHeldStocks = useAppSelector(selectMostHeldStocks);
    useFetchMostHeldStocks(shouldFetch);
    return mostHeldStocks?.slice(0, MOST_HELD_STOCKS_LIMIT);
}
export default useMostHeldStocks;
